import Cookies from 'js-cookie'
import { startTransition, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router'
import { useLocation, useNavigate } from 'react-router-dom'

import {
  fetchFilter as getFilter,
  fetchFlowProducts,
  fetchProducts
} from '@api/hernest/products/productsSlice'
import { routesPath } from '@api/hernest/utils'
import { fetchHomeDataV2 } from '@api/home/home/homeSlice'
import useGlobalEvent from '@hooks/useGlobalEvent'
import { getRelativeUrl, isBrowser, isMobileProject } from '@utils'
import { Knife, Type } from '@utils/tool'
import winPixel from '@utils/winPixel'

const { camelCase, camelCaseToUnderline } = Knife

export const getCategoryId = (pathname) => {
  let id = ''
  if (pathname.search(/^\/category\/.*-c-\d+.html/i) > -1) {
    id = pathname
      .match(/-c-\d+.html/)[0]
      .substring(3)
      .split('.')[0]
  } else if (pathname.search(/^\/custompro\/\d+/i) > -1) {
    id = pathname.split('/custompro/')?.[1]
  } else if (pathname.search(/^\/best-sellers\/\d+/i) > -1) {
    id = pathname.split('/best-sellers/')?.[1]
  }
  return id
}

// url参数 搜索页兼容keywords= 和q=
export const urlQueryHandle = (str: string) => {
  const query = str
  const arr = query ? query.split('&') : []
  const result: any = arr.reduce((obj, item) => {
    // 兼容输入 = 号开始的关键字
    if (item.indexOf('keywords') > -1 || item.indexOf('q=') > -1) {
      const value =
        item.match(/^keywords=(.*)/)?.[1] || item.match(/^q=(.*)/)?.[1]
      obj['keywords'] = value
    } else {
      const [key, value] = item.split('=')
      obj[key] = value
    }
    return obj
  }, {})
  return camelCase(result)
}

export const useEntry = (props?: {
  pathname?
  isScroll?: boolean
  rejectProductsId?
  pageData?: any
  pageSize?
}) => {
  const cookieParams = Cookies.get('recordProductCookie')
  const jsonCookie = (cookieParams && JSON.parse(cookieParams)) || {}
  const { cookieFetch, authUrl } = jsonCookie

  const { pageSize = 24 } = props
  const ssrData = props.pageData || {}
  const { isScroll = true, rejectProductsId: item_products_id } = props
  const location = useLocation()
  const urlParams = useParams() || {}
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const pathname = props?.pathname || location.pathname
  let isCategory = pathname.indexOf('/c/') > -1
  const isSearch = pathname.indexOf('/search') > -1
  const isCustompro =
    pathname.indexOf('/custompro/') > -1 ||
    pathname.indexOf('/best-sellers/') > -1
  const isFlash = pathname.indexOf('/flashDeal') > -1
  const isMobild = isMobileProject

  let { id } = urlParams
  // 兼容链接
  if (pathname.search(/^\/category\/.*-c-\d+.html/i) > -1) {
    id = pathname
      .match(/-c-\d+.html/)[0]
      .substring(3)
      .split('.')[0]
    isCategory = true
  }

  // 类目页、搜索页、闪购页、custompro接口参数集合
  const [normalParams, setNormalParams]: any = useState({
    page: isMobild ? null : 1,
    pageSize: pageSize,
    order: '1',
    filterValueIds: undefined,
    filterCat: undefined, // category
    minPrice: undefined,
    maxPrice: undefined
  })

  // 热销:/hot、新品页:/new 在用，接口参数集合
  const [flowParams, setFlowParams]: any = useState({
    page: isMobild ? null : 1,
    pageSize: 32
  })

  // 筛选数据
  const [filterData, setFilterData]: any = useState({
    filterList: [],
    orderSelect: []
  })
  const [authorityUrl, setAuthorityUrl] = useState(authUrl || '') // 当前url
  const [hasFetch, setFetch] = useState(cookieFetch || false) // 标记是否落地

  const [pageType, setPageType] = useState(0) // 活动页面标识
  const [initLoading, setInitLoading] = useState(false)
  const [showSkeletonList, setShowSkeletonList] = useState(false)
  const [pageValue, setPageValue] = useState(1)
  const [hasMore, setHasMore] = useState(true)
  const [isEndTime, setIsEndTime] = useState(true) // 闪购时间是否彻底为0
  const [hideFilter, setHideFilter] = useState(true) // 显隐筛选器,默认隐藏

  // m端-离开当前列表页记最后的页面状态，回退页面使用
  const leavePage = () => {
    // 记录cookie
    const cookieParams = JSON.stringify({
      ...normalParams,
      page: pageValue,
      loadingMore: hasMore,
      cookieRecord: true,
      cookieFetch: true,
      pathUrl: location.pathname,
      authUrl: authorityUrl
    })
    Cookies.set('recordProductCookie', cookieParams)
  }

  const removeCookieFn = () => {
    Cookies.remove('recordProductCookie')
  }

  // 获取筛选数据
  const fetchFilter = (params: any = {}) => {
    const obj = {
      ...params,
      item_products_id
    }
    if (isFlash) {
      obj.flowType = 'flash'
    } else if (isCustompro) {
      obj.flowType = 'custompro'
    }
    dispatch(getFilter({ ...obj })).then((res) => {
      const { filterList, orderSelect } = res?.payload?.data || {}
      let listFilter = []
      filterList.map((item: any) => {
        if (item.productsOptionValuesList) {
          listFilter = listFilter.concat(item.productsOptionValuesList)
        }
      })
      setFilterData({
        filterList: listFilter,
        orderSelect
      })
    })
  }

  // 发起请求
  const fetchApi = (isFlow, isMobild) => {
    if (isFlow) {
      let obj = { ...flowParams }
      if (isMobild) {
        obj.page = pageValue
      }
      return fetchFlowProducts(obj)
    } else {
      let obj = {
        ...normalParams,
        item_products_id,
        jumpTagRedirect: !!item_products_id ? 0 : undefined
      }

      if (isMobild && !item_products_id) {
        obj.page = pageValue
      }
      delete obj.hideFilter
      return isFlash
        ? fetchFlowProducts(obj)
        : fetchProducts({ url_path: location.pathname || '', ...obj })
    }
  }

  // pc回到列表顶部
  const getPcScrollHeight = () => {
    try {
      const $topad = document
        .getElementById('js-topad')
        ?.getBoundingClientRect() || { height: 48 }
      const $header = document
        .getElementById('header')
        ?.getBoundingClientRect() || { height: 117 }
      const $bread = document
        .getElementById('js-bread')
        ?.getBoundingClientRect() || { height: 51 }
      let h = 0
      // h = 168 + (window.innerWidth / 1920) * 400
      const elementId = isSearch ? 'js-searchTitle' : 'js-productBanner'
      const $divR = document
        .getElementById(elementId)
        ?.getBoundingClientRect() || { height: 200 }

      h = $topad.height + $header.height + $divR.height
      if (isCategory) {
        h += $bread.height
      }
      return Type.number(normalParams.manualControl) === 1 ? h : 0
    } catch (err) {
      console.error('pc高度计算异常')
    }
  }

  // m回到列表顶部
  const getMScrollHeight = () => {
    try {
      const $topad = document
        .getElementById('js-topad')
        ?.getBoundingClientRect() || { height: 40 }
      const $bread = document
        .getElementById('js-bread')
        ?.getBoundingClientRect() || { height: 40 }
      let h = 0
      // if (isCustompro) {
      //   h = (window.innerWidth / 750) * 420
      // } else {
      //   h = (window.innerWidth / 750) * 512
      // }
      const elementId = isSearch ? 'js-searchTitle' : 'js-productBanner'
      const $divR = document
        .getElementById(elementId)
        ?.getBoundingClientRect() || { height: 160 }
      h = $topad.height + $divR.height
      if (isCategory) {
        h += $bread.height
      }
      return Type.number(normalParams.manualControl) === 1 ? h : 0
    } catch (err) {
      console.error('m高度计算异常')
    }
  }

  // PC端接口回调处理
  const callBackPC = (res) => {
    if (res?.payload?.data?.redirectUrl) {
      navigate(getRelativeUrl(res?.payload?.data?.redirectUrl))
    }
    setAuthorityUrl(res?.payload?.data?.authorityUrl)
    setShowSkeletonList(false)
    setInitLoading(false)
    setFetch(true)
    if (isSearch && normalParams.keywords) {
      winPixel.search(normalParams.keywords, res?.payload?.data?.productCount)
    }
  }

  // M端接口回调处理
  const callBackM = (res) => {
    if (res?.payload?.data?.redirectUrl) {
      navigate(getRelativeUrl(res?.payload?.data?.redirectUrl))
    }
    setAuthorityUrl(res?.payload?.data?.authorityUrl)
    setInitLoading(false)
    setFetch(true)
    const data = res.payload.data
    // 最后一页
    if (Number(data.pageTotal) === Number(data.page)) {
      setHasMore(false)
    } else {
      setPageValue(Number(data.page) + 1)
      setHasMore(true)
    }

    if (isSearch && normalParams.keywords) {
      winPixel.search(normalParams.keywords, res?.payload?.data?.productCount)
    }
    removeCookieFn()
  }

  const scrollPc = () => {
    if (isBrowser) {
      const sHeight = getPcScrollHeight()
      setTimeout(() => {
        window?.scrollTo({
          top: sHeight,
          behavior: 'smooth'
        })
      })
    }
  }

  //接收重新刷新list数据的事件
  useGlobalEvent('refetchCategoryList', () => {
    setNormalParams({ ...normalParams })
  })

  //接收派发catelist高度变化的命令
  useGlobalEvent('updateCateListHeight', scrollPc)

  // 请求商品列表数据
  const fetchData = (isFlow?: boolean): Promise<any> => {
    if (isMobild) {
      // m接口请求逻辑
      if (pageValue === 1 && isScroll) {
        isBrowser &&
          setTimeout(() => {
            const sHeight = getMScrollHeight()
            window?.scrollTo({
              top: sHeight,
              behavior: 'smooth'
            })
          })
      }
      const apiFunc = fetchApi(isFlow, isMobild)
      return new Promise((resolve, reject) => {
        setInitLoading(true)
        dispatch(apiFunc).then((res) => {
          callBackM(res)
          resolve(res)
          if (Number(res.flashEndTime) === 0) {
            setIsEndTime(true)
          } else {
            setIsEndTime(false)
          }
        })
      })
    } else {
      // pc接口请求逻辑
      !item_products_id && setShowSkeletonList(true)

      if (isScroll) {
        scrollPc()
      }
      const apiFunc = fetchApi(isFlow, false)
      dispatch(apiFunc).then((res) => {
        callBackPC(res)
        if (Number(res.flashEndTime) === 0) {
          setIsEndTime(true)
        } else {
          setIsEndTime(false)
        }
      })
    }
  }

  const handleCookieFetchData = () => {
    const cookieParams = Cookies.get('recordProductCookie')
    const { cookieRecord } = (cookieParams && JSON.parse(cookieParams)) || {}
    if (cookieRecord) {
      return
    }
    fetchData()
  }

  // url链接处理
  const handleUrl = (newForm?: any, extraUrl?: any, toggle?: boolean) => {
    // 生成url 文案
    let urlText = ''
    try {
      const { filterValueIds } = newForm
      // 暂时类目页处理文案拼接
      if (isCategory && newForm.filterValueIds) {
        if (filterValueIds) {
          const arr = filterValueIds.split(',') || []
          arr.map((id) => {
            filterData.filterList.map((fl) => {
              if (
                id === fl.productsOptionsValuesId &&
                fl.productsOptionsId !== 'p' &&
                fl.productsOptionsId !== 'c'
              ) {
                urlText += `-${fl.productsOptionsValuesName}`
              }
            })
          })
        }
      }
    } catch (err) {}

    const urlForm = camelCaseToUnderline(newForm)
    // 需要保留字段
    if (!toggle) {
      urlForm.hide_filter = hideFilter ? 1 : 0
    }
    //遍历object,并进行拼接
    let filterList = Object.keys(urlForm).reduce((acc, key) => {
      if (urlForm[key] !== undefined && urlForm[key] !== '') {
        if (!Array.isArray(urlForm[key])) {
          acc.push(`&${key}=${urlForm[key]}`)
        } else {
          urlForm[key].forEach((value) => {
            acc.push(`&${key}[]=${value}`)
          })
        }
      }
      return acc
    }, [])
    const query = filterList.join('').substring(1)

    // 特殊页面处理
    if (isCustompro) {
      const newUrl = location.pathname + '?' + query
      navigate(`${newUrl}`)
      return
    }
    const url = authorityUrl || extraUrl
    const [matchedStart, matchedEnd] = url?.split('-c-') || [] // 匹配-c-前后
    const hasSpec = `${urlText
      ?.toLocaleLowerCase()
      .replace(/[^a-zA-Z0-9]/g, '-')}`
    const catUrl = `${matchedStart}${hasSpec}-c-${matchedEnd}`
    const newUrl = `${isCategory ? catUrl : location.pathname}?${query}`

    if (props.pathname) {
      navigate(`${location.pathname}?${query}`)
    } else {
      navigate(`${newUrl}`)
    }
  }

  // 类目页、搜索页、闪购页、custompro: 接口参数更新，并拼接参数到url显示
  const handleFetch = (newParams: any, extraUrl = '') => {
    if (isMobild) {
      setPageValue(1)
      setInitLoading(true)
    }
    // 更新到url
    const newForm = { ...normalParams, ...newParams }
    setNormalParams((prevForm: any) => ({
      ...prevForm,
      ...newParams
    }))
    delete newForm.page
    delete newForm.pageSize
    handleUrl(newForm, extraUrl)
    removeCookieFn()
  }

  // 切换页码
  const handlePage = (page: number, pageSize: number) => {
    const obj = Knife.clearjunk({ page, pageSize })

    if (isCategory || isSearch || isCustompro || isFlash) {
      setNormalParams((prevForm: any) => ({
        ...prevForm,
        ...obj
      }))
    } else {
      setFlowParams((prevForm: any) => ({
        ...prevForm,
        ...obj
      }))
    }
    removeCookieFn()
  }

  // 闪购页活动时间是否为0 ，为0重新请求接口获取新的倒计时
  const endTimeCallback = () => {
    // if (isEndTime) return
    fetchData()
  }

  // 显隐筛选器
  const toggleFilter = () => {
    const newValue = !hideFilter
    setHideFilter(newValue)
    // 更新到url
    const search = location.search ? location.search.substring(1) : ''
    const result = urlQueryHandle(search)
    const newObj = {
      ...result,
      hide_filter: newValue ? 1 : 0
    }
    handleUrl(newObj, '', true)
  }

  useEffect(() => {
    startTransition(() => {
      if (!normalParams.catId && !normalParams.keywords && !normalParams.type) {
        setInitLoading(false)
        return
      }
      handleCookieFetchData()
    })
  }, [normalParams])

  // 活动参数更新，触发请求接口
  useEffect(() => {
    startTransition(() => {
      if (!flowParams.type) {
        setInitLoading(false)
        return
      }
      fetchData(true)
    })
  }, [flowParams])

  // 处理是否有url参数，如果没有要把旧数据清除
  const resetParams = () => {
    const search = location.search ? location.search.substring(1) : ''
    const newData = { ...normalParams }
    const result = urlQueryHandle(search)
    const {
      order,
      filterValueIds,
      filterCat,
      minPrice,
      maxPrice,
      minWidth,
      maxWidth,
      minDepth,
      maxDepth,
      minHeight,
      maxHeight,
      onSale,
      inStock,
      quickShip,
      manualControl,
      hideFilter
    } = result
    newData.page = 1
    newData.order = order || '1'
    newData.filterValueIds = filterValueIds || undefined
    newData.filterCat = filterCat || undefined
    newData.minPrice = minPrice || undefined
    newData.maxPrice = maxPrice || undefined
    newData.minWidth = minWidth || undefined
    newData.maxWidth = maxWidth || undefined
    newData.minDepth = minDepth || undefined
    newData.maxDepth = maxDepth || undefined
    newData.minHeight = minHeight || undefined
    newData.maxHeight = maxHeight || undefined
    newData.onSale = onSale || undefined
    newData.inStock = inStock || undefined
    newData.quickShip = quickShip || undefined
    newData.manualControl = manualControl || undefined
    newData.hideFilter = [1, 0].includes(Number(hideFilter))
      ? Number(hideFilter) === 1
      : true
    return newData
  }

  // 监听url变化, 首次执行
  useEffect(() => {
    const cookieParams = Cookies.get('recordProductCookie')
    const {
      page,
      loadingMore,
      cookieRecord,
      cookieFetch,
      pathUrl,
      authUrl,
      ...rest
    } = (cookieParams && JSON.parse(cookieParams)) || {}
    // 列表页->详情页回退，需要实现定位和缓存
    if (
      JSON.stringify(cookieParams) !== '{}' &&
      pathUrl === location.pathname
    ) {
      // 读取缓存更新
      const record = { ...rest }
      setPageValue(page)
      setHasMore(loadingMore)
      setNormalParams((prevForm: any) => ({
        ...prevForm,
        ...record
      }))
      return
    } else {
      setPageType(0)
      isMobild && setPageValue(1)
      setInitLoading(true)
      const search = location.search ? location.search.substring(1) : ''
      const { hideFilter, ...rest } = urlQueryHandle(search)
      const result = { ...rest }
      let addObj: any = {
        page: isMobild ? null : 1
      }
      setHideFilter(
        [1, 0].includes(Number(hideFilter)) ? Number(hideFilter) === 1 : true
      )
      removeCookieFn()
      // 类目页、搜索页、自定义产品集合页、闪购页
      if (isCategory || isSearch || isCustompro || isFlash) {
        if (isCategory || isCustompro) {
          addObj.catId = id
        }

        // 存在类目id或者关键字，则获取筛选数据
        if (addObj.catId || result.keywords) {
          let obj: any = { url_path: location.pathname }
          addObj.catId && (obj.catId = addObj.catId)
          result.keywords && (obj.keywords = result.keywords)
          fetchFilter(obj)
        } // 是闪购页
        else if (isFlash) {
          fetchFilter({ url_path: location.pathname })
          addObj.type = 1
          setPageType(1)
          dispatch(
            fetchHomeDataV2({
              terminal: isMobild ? 'm' : 'pc',
              page: 'category'
            })
          )
        }
        // 商品接口更新并自动触发请求
        const newParams = { ...result, ...addObj }
        setNormalParams((prevForm: any) => ({
          ...prevForm,
          ...newParams
        }))
      } else {
        if (pathname.indexOf(routesPath.hot) > -1) {
          // 热销页
          addObj.type = 2
          setPageType(2)
        } else if (pathname.indexOf(routesPath.new) > -1) {
          // 新品页
          addObj.type = 3
          setPageType(3)
        }
        const newParams = { ...result, ...addObj }
        setFlowParams((prevForm: any) => ({
          ...prevForm,
          ...newParams
        }))
      }
    }
  }, [])

  // 当搜索页关键词变化时，直接请求数据
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search)
    const newKeyword = searchParams.get('keywords') || searchParams.get('q')
    const oldKeyword = normalParams.keywords
    if (oldKeyword && oldKeyword !== newKeyword) {
      const { hideFilter, ...rest } = resetParams()
      let data = { ...rest }
      setHideFilter(hideFilter)
      removeCookieFn()
      data.keywords = newKeyword
      isMobild && setPageValue(1)
      setInitLoading(true)
      setNormalParams(data)
      fetchFilter({ keywords: newKeyword, url_path: location.pathname })
    }
  }, [location.search])

  // 监听类目id变化，直接请求数据
  useEffect(() => {
    const oldCatId = normalParams.catId
    if (oldCatId && oldCatId !== id) {
      const { hideFilter, ...rest } = resetParams()
      let data = { ...rest }
      setHideFilter(hideFilter)
      removeCookieFn()
      data.catId = id
      isMobild && setPageValue(1)
      setInitLoading(true)
      setNormalParams(data)
      fetchFilter({ catId: id, url_path: location.pathname })
    }
  }, [id])

  return {
    isCustomTitle: !Type.isNever(props.pathname),
    initLoading,
    isFlash,
    isSearch,
    isCategory,
    isCustompro,
    normalParams,
    flowParams,
    showSkeletonList,
    pageType,
    handleFetch,
    handlePage,
    setInitLoading,
    hasMore,
    fetchData,
    hasFetch,
    ssrMetaInfo: ssrData.metaInfo,
    endTimeCallback,
    hideFilter,
    toggleFilter,
    leavePage
  }
}
